<template>
  <VanPopup
    v-model:show="modalStore.showCustomGlobalActionSheet"
    closeable
    round
    class="min-w-[60%]"
  >
    <div class="flex flex-col gap-4 px-4 py-10">
      <h3 class="px-6 text-center text-lg font-bold">
        {{ modalStore.customGlobalActionSheetTitle }}
      </h3>
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
          <div
            v-for="item in modalStore.customGlobalActionSheetList"
            :key="item.content"
            class="flex items-center justify-center w-full"
          >
            <button
              :class="[
                'btn min-w-[100px] justify-center w-full',
                item.className,
              ]"
              @click="
                modalStore.showCustomGlobalActionSheet = false;
                item.callback?.();
              "
            >
              <span
                class="flex items-center gap-1"
                v-html="item.content"
              ></span>

              <span
                v-if="item.paymentInfo"
                class="text-sm flex items-center gap-1"
              >
                <PowerIcon v-if="item.paymentInfo.type === 'power'" />
                <CrystalIcon v-if="item.paymentInfo.type === 'crystal'" />
                {{ item.paymentInfo?.amount }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { useGlobalModal } from "@/stores/globalModal";

const modalStore = useGlobalModal();
</script>
